// Login, Refresh und Logout dürfen NICHT in die Refresh-Pipeline, sonst Endlosschleife.
const authEndpoints = ['/api/v1/auth/login', '/api/v1/auth/refresh', '/api/v1/auth/logout'];

/**
 * Eine abgelehnte Bestätigung — falsches Passwort, schon benutzter Code, gesperrtes Konto — ist
 * keine abgelaufene Sitzung. Ein Refresh änderte nichts, und die Wiederholung derselben Eingabe
 * zählte den Fehlversuch doppelt, bis das Konto nach drei Tippfehlern gesperrt war.
 */
const confirmationFailures = new Set([
  'Auth.ReauthenticationFailed',
  'Auth.InvalidTwoFactorCode',
  'Auth.LockedOut',
]);

/** Ob dieser 401 ohne Refresh und Wiederholung beim Aufrufer ankommt. */
export async function skipsRefresh(path: string, response: Response): Promise<boolean> {
  if (authEndpoints.some((auth) => path.endsWith(auth))) return true;
  try {
    // Geklont: der Aufrufer liest den Grund danach selbst.
    const problem = (await response.clone().json()) as { title?: unknown };
    return typeof problem.title === 'string' && confirmationFailures.has(problem.title);
  } catch {
    // Der 401 der Anmeldeschicht hat keinen Körper: das ist die abgelaufene Sitzung.
    return false;
  }
}
